module.exports = __webpack_public_path__ + "img/checkw.73330d18.svg";